@if (this.gradientConfig['layout'] === 'vertical') {
  <app-scrollbar (clickOutside)="navMob()" id="nav-ps-gradient-able" [customStyle]="'calc(100vh - 56px)'">
    <div class="navbar-content">
      <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()">
        @for (items of navigation; track items) {
          @if (items.type === 'group') {
            <app-nav-group [item]="items" />
          }
        }
      </ul>
      <!-- <app-card [hidHeader]="true" cardClass="text-center">
        <i class="feather icon-sunset f-40"></i>
        <h6 class="mt-3">Help?</h6>
        <p>Please contact us on our email for need any support</p>
        <a href="https://codedthemes.support-hub.io/" target="_blank" class="btn btn-primary btn-sm text-white m-0">Support</a>
      
      </app-card> -->
      <!-- <div class="version">
        <label disabled class="pe-auto">v{{ currentApplicationVersion }}</label>
      </div> -->
    </div>
  </app-scrollbar>
}
@if (this.gradientConfig['layout'] === 'horizontal') {
  <div #navbarWrapper class="navbar-content sidenav-horizontal" id="layout-sidenav">
    <a href="javascript:" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
    <div class="sidenav-horizontal-wrapper">
      <ul
        #navbarContent
        id="side-nav-horizontal"
        class="nav pcoded-inner-navbar sidenav-inner"
        (clickOutside)="fireLeave()"
        (mouseleave)="fireLeave()"
      >
        @for (items of navigation; track items) {
          @if (items.type === 'group') {
            <app-nav-group [item]="items" />
          }
        }
      </ul>
    </div>
    <a href="javascript:" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
  </div>
}
